// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  Application: 'Search.Label.Application',
  Default: 'certs.label.default',
  Applied: 'CERTS_FILTERS_APPLIED',
};

export default invertedMessages;
